import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@mui/material';
import { getDownloadFileName, getLocaleDateTime, getUploadFileFullPathDownload, getUserFullName } from 'app/utils/appHelpers';
import config from 'config';
import { redColor } from 'app/themes/main/default';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import IFrameLinkDialog from '../Dialog/IFrameLinkDialog';
import CustomTooltip from '../Tooltip/CustomTooltip';

function AgendaFileListTable({ agendaFileList, handleDeleteItem }) {
  const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');

  const openFile = async (meeting, fileObj) => {
    const filename = fileObj.id + fileObj.ext;
    let fileFolderName = "";
    fileFolderName = "meetingFiles/" + currentMeeting.inst + "-" + currentMeeting.id;
    const downloadName = getDownloadFileName(meeting, fileObj);
    getUploadFileFullPathDownload(fileFolderName, filename, downloadName);
  };

  const handleLinkClick = (url) => {
    setIframeUrl(url);
    setDialogOpen(true);
  };

  const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.svg']; // Add more extensions if needed

  return (
    <>
      <Table size='small' sx={{ lineHeight: 1 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ lineHeight: 1 }}>Id</TableCell>
            <TableCell sx={{ lineHeight: 1 }}>Kullanıcı</TableCell>
            <TableCell sx={{ lineHeight: 1 }}>Dosya Tipi</TableCell>
            <TableCell sx={{ lineHeight: 1 }}>Tarih</TableCell>
            <TableCell sx={{ lineHeight: 1 }}>İşlemler</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {agendaFileList.length > 0 ? (
            agendaFileList.map((item, index) => {
              const isImage = imageExtensions.includes(item.ext.toLowerCase());
              const fileUrl = config.apiUrl + "/uploads" + "/" + `meetingFiles/${currentMeeting.inst}-${currentMeeting.id}/${item.id}${item.ext}`;
              const displayFileType = item.fileInfo ? "Bağlantı: " + item.fileType : item.fileType + item.ext;
              const linkUrl = (item.fileInfo || item.fileInfo !== "") ? item.fileInfo : fileUrl;

              return (
                <TableRow key={item.id}>
                  <TableCell sx={{ lineHeight: 1 }}>{index + 1}</TableCell>
                  <TableCell sx={{ lineHeight: 1 }}>
                    {getUserFullName(item.user)}
                  </TableCell>
                  <TableCell sx={{ lineHeight: 1 }}>
                    <CustomTooltip
                      title={
                        isImage && !item.fileInfo ? (
                          <img
                            src={fileUrl}
                            alt="Preview"
                            style={{
                              maxWidth: '500px',
                              maxHeight: '500px',
                              objectFit: 'contain',
                              backgroundColor: 'white',
                              padding: '8px'
                            }}
                          />
                        ) : ''
                      }
                      placement="right"
                      arrow
                      sx={{
                        '& .MuiTooltip-tooltip': {
                          padding: '8px',
                        }
                      }}
                    >
                      <a
                        href="#"
                        style={{
                          textDecoration: "none",
                          color: "inherit",
                          fontWeight: "400",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = redColor;
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = "inherit";
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          if (item.fileInfo) {
                            handleLinkClick(linkUrl);
                          } else {
                            openFile(currentMeeting, item);
                          }
                        }}
                      >
                        {displayFileType}
                      </a>
                    </CustomTooltip>
                  </TableCell>
                  <TableCell sx={{ lineHeight: 1 }}>{getLocaleDateTime(item.pdate)}</TableCell>
                  <TableCell sx={{ lineHeight: 1 }}>
                    <Button  key="two"
                      onClick={() => {
                        handleDeleteItem(item);
                      }}
                    >
                      <DeleteIcon color='error' sx={{  }} />
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={5} align="center" sx={{ lineHeight: 1 }}>
                Dosya bulunmamaktadır
              </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
        </TableFooter>
      </Table>

      {dialogOpen && (
        <IFrameLinkDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          iframeUrl={iframeUrl}
        />

      )}
    </>
  );
}

export default AgendaFileListTable;